import React from 'react'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

const LeadMacrosTableBody = ({ index, isLastIndex, macro, checked_macro_Key_stats, launchFormatterModal, launchMappingModal, duplicateMacrosMapping, readOnly = false }) => {
    return (
        <div className={`accordion-item bg-white ${index === 0 ? "" : "border-top-0"} ${isLastIndex ? "border-bottom-0" : ""} border-start-0 border-end-0`}>
            <div key={`_id_macro_${index}`} className="d-flex justify-content-between bm-3" style={{ padding: "0.3rem 0.35rem" }}>
                <div className="left d-flex align-items-center">
                    <span style={{ width: "22px" }}>
                        {checked_macro_Key_stats?.includes(macro.key) ? (<i className="bx text-light rounded-circle font-size-13 bx-check fw-bold bg-success" />) : (<i className="bx text-light rounded-circle font-size-13 bx-check fw-bold bg-success d-none" />)}
                    </span>

                    <span className='font-size-13'>{readOnly ? macro.display_key : <a onClick={() => launchFormatterModal(macro)} className='text-black'>{macro.display_key}</a>} </span>
                </div>
                {!readOnly && <div className="right">
                    <div className="d-flex gap-3 justify-content-start">
                        <UncontrolledDropdown>
                            <DropdownToggle href="#" className="card-drop" tag="i" style={{ cursor: 'pointer' }}>
                                <i className="mdi mdi-dots-horizontal font-size-18" />
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <DropdownItem header className='text-black'>Options</DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem onClick={() => launchFormatterModal(macro)}>
                                    Custom Format
                                </DropdownItem>
                                <DropdownItem onClick={() => launchMappingModal(macro)}>
                                    Custom Mapping
                                </DropdownItem>
                                <DropdownItem onClick={() => duplicateMacrosMapping(macro)}>
                                    Duplicate
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>}
            </div>
        </div>
    )
}

export default LeadMacrosTableBody;
